// extracted by mini-css-extract-plugin
export default {"info":"Y286o","time":"_3BpBl","title":"jSROG","ellipsis":"_1U6f-","more":"_1a4K-"};